<div class="col-12 p-0 _trm-n-con">
  <label class="kx-check-wrapper m-0">{{'field.label.I_agree_to_the' | translate | async }}
    <input type="checkbox" class="checkbox" [(ngModel)]="consentCheck" name="consent" [disabled]="disabledButton" required>
    <span class="kx-check"></span>
  </label>
  <span (click)="showTnc()" style="color: #00ACF1;cursor: pointer;"><strong> {{'field.label.terms_of_service' | translate | async }}</strong></span>
</div>
@if (!disabledButton) {
  <div class="py-3 button-center" align="center">
    <button class="primary-btn btn-md px-5" (click)="updateConsent()">Update</button>
  </div>
}
@if (disabledButton && consentTime) {
  <span class="kx-check-wrapper m-0">Consent given on <strong> {{consentTime}}</strong></span>
}
